export default "__VITE_ASSET__BqRwDH4d__"